import React from "react";

export default function NotificationDay({ day }) {
  return (
    <div>
      <p className="mt-8 text-xl ml-3">{day}</p>
    </div>
  );
}
